var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TAN_REQUEST_FAILURE, TAN_REQUEST_SUCCESS, TAN_RESEND_FAILURE, TAN_VALIDATE_FAILURE, TAN_VALIDATE_SUCCESS, } from '../actions';
var rvWizardReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case TAN_REQUEST_SUCCESS:
        case TAN_VALIDATE_SUCCESS:
            return __assign(__assign({}, state), { rv_tan: {
                    step: state.rv_tan.step + 1,
                } });
        case TAN_REQUEST_FAILURE:
        case TAN_VALIDATE_FAILURE:
        case TAN_RESEND_FAILURE:
            return __assign(__assign({}, state), { rv_tan: __assign(__assign({}, state.rv_tan), { error: action.error }) });
        default:
            return state;
    }
};
export default rvWizardReducer;
